/**
 * SmartTempoToggle Component
 * Toggle for Smart Tempo panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Activity } from 'lucide-react';

export const SmartTempoToggle = ({
  showSmartTempo,
  setShowSmartTempo,
  isSimplifiedMode = false,
}) => {
  if (isSimplifiedMode) return null;
  
  return (
    <Button
      variant={showSmartTempo ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowSmartTempo(!showSmartTempo)}
      className={`relative p-2 ${showSmartTempo ? 'bg-amber-500/20 text-amber-400 border border-amber-500/50' : 'text-zinc-400 hover:text-white hover:bg-amber-500/20'}`}
      data-testid="smart-tempo-btn"
      title="Smart Tempo - Auto-detect tempo from audio"
    >
      <Activity className="w-5 h-5" />
    </Button>
  );
};

export default SmartTempoToggle;
